import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';

export default function News() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="华辉动态 | 华辉数智"
        description="记录产品进展、行业洞察与合作实践，所有内容按实际发布日期持续更新。"
        keywords="华辉动态,产品进展,行业洞察,合作实践"
        path="/news"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '华辉动态',
          description: '记录产品进展、行业洞察与合作实践，所有内容按实际发布日期持续更新。',
        }}
      />

      {/* 空白占位区域 */}
      <main className="w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto min-h-[60vh]" />
      </main>

      <Footer />
    </div>
  );
}